var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('button',{staticClass:"sns_login_wrap mr22 kakao",on:{"click":function($event){return _vm.triggerKakao()}}},[_c('a',{staticStyle:{"display":"none"},attrs:{"id":"kakao-login-btn"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }